export const meta = () => {
	return [{ title: 'Store | EBHS' }]
}

export default function Store() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Honor Bricks
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
					<div className="m-3 w-full max-w-sm rounded-lg bg-white p-3 lg:flex lg:max-w-full">
						<div className="m-3 h-48 flex-none overflow-hidden bg-cover text-center lg:h-auto lg:w-48">
							<img
								className="w-full"
								src="/images/ebhs/store/bricks.png"
								alt="Bricks engraved with a name"
							/>
						</div>
						<div className="flex flex-col justify-between p-4 leading-normal">
							<div className="mb-8">
								<div className="mb-2 text-2xl font-semibold text-gray-900">
									Honor Bricks
								</div>
								<p className="mt-2 text-lg text-gray-700">
									Honor bricks are a timeless way to honor a loved one, family
									member, spouse, or yourself. The bricks also offer an
									excellent way to pay tribute to a distinguished member of the
									community. Your brick placed in the walkway to the entrance
									of the Academy museum will be viewed by all who visit the
									Historical Society. The durable red brick, sized 8 inches
									wide by 4 inches high, will accommodate up to 3 engraved
									lines.
								</p>
								<form
									action="https://www.paypal.com/donate"
									method="post"
									className="p-3"
									target="_blank"
								>
									To complete your purchase, please contact us at 585-657-7244.
									If you wish to pay online, you can submit your payment here:{' '}
									<input
										type="hidden"
										name="hosted_button_id"
										value="77YWK8A2WPZ8N"
									/>
									<button
										type="submit"
										className="inline-flex items-center rounded-full border border-transparent bg-ebhs-blue px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-ebhs-blue-light focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
									>
										Donate
									</button>
								</form>
							</div>
							<div className="px-6 py-4">
								<span className="mr-2 inline-block rounded-full bg-green-200 px-3 py-1 text-xl font-semibold text-gray-700">
									$64.50
								</span>
								<a
									href="https://ebhs1838.s3.amazonaws.com/brick_order_form.pdf"
									className="ml-4 text-lg text-ebhs-blue underline"
								>
									Brick Order Form
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<header className="px-4 py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						EBHS Books &amp; Media
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
					<div className="text-lg">
						<form
							action="https://www.paypal.com/donate"
							method="post"
							target="_blank"
						>
							Prices include applicable tax and shipping costs within the
							United States. To complete your purchase, please contact us at{' '}
							<a href="tel:5856577244">585-657-7244</a>. If you wish to pay
							online, you can submit your payment here:{' '}
							<input
								type="hidden"
								name="hosted_button_id"
								value="77YWK8A2WPZ8N"
							/>
							<button
								type="submit"
								className="inline-flex items-center rounded-full border border-transparent bg-ebhs-blue px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-ebhs-blue-light focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
							>
								Donate
							</button>
						</form>
					</div>

					<Book
						title="Roadside Craftsmen"
						author="Laurel Wemett"
						description='DVD Recording of "A group of Spirited Workers: A History of the Roadside Craftsmen." Runtime 13 minutes.'
						price="5"
						image="/images/ebhs/store/roadside_craftsmen.png"
					/>
					<Book
						title="Dear Mrs. Steele, Thank you..."
						author="Judi Stewart and Dianne Crowley"
						description='Wikipedia defines a time capsule as "a historic cache of goods or information." The story in this book is such a time capsule that begins in 1942 and ends in 1945. This book contains letters from soldiers and family members who wrote to Mrs. Lena Steele over that period. The letters, which were recently found, appeared to be untouched from the time they were placed in a small box until discovered in the fall of 2019; an appropriate description of a time capsule. The book offers a snapshot of young men and women sent to war and their deep bond to the community in which they grew up. It is dedicated to the soldiers and the woman, Lena Steele, who kept that bond alive for them during those war years.'
						price="32.50"
						image="/images/ebhs/store/mrssteele.png"
					/>
					<Book
						title="Elton Park and the Monument of East Bloomfield"
						author="Sandra Bortle Schlenker"
						description="History of Elton Park, the Civil War Monument with profiles of Civil War soldiers and Civil War letters written by Oscar Parker."
						price="10.25"
						image="/images/ebhs/store/eltonpark.png"
					/>
					<Book
						title="Memories and Traditions of Bloomfield 1789 - 1989"
						author="Virginia Schroeder and Marilyn Herr-Gesell"
						description="The history of Bloomfield, N.Y. starting with the Native Americans, Phelps Gorham purchase, early settlers and their families, Taverns and Inns, Churches, Schools and Industries and Businesses."
						price="10.56"
						image="/images/ebhs/store/memoriesandtraditions.png"
					/>
					<Book
						title="Bloomfield Schools Revisited: A History of Education in East Bloomfield 1789 - 1989"
						author="Margaret G. Parshall, Virginia Schroeder, Annita Breitweiser"
						description="History of educational institutions beginning with District 10 of the first settlement in Bloomfield, N.Y. to the current centralized school system."
						price="5.76"
						image="/images/ebhs/store/bloomfieldschoolsrevisited.png"
					/>
					<Book
						title="Telling It Like It Was East Bloomfield Historical Society's First 50 Years"
						author="Paul Hudson"
						description='In celebration of the Society&#39;s 50th anniversary, this book stitches together the history of East Bloomfield Historical Society using "newspaper articles, reports, Society minutes, historical files and ephemera dating back over a century."'
						price="18.75"
						image="/images/ebhs/store/tellingitlikeitwas.png"
					/>
					<Book
						title="The War Years in Bloomfield 1941-1945"
						author="Diana J. Wade, Town Historian"
						description="The book is a compilation of the East Bloomfield Review, a newsletter produced by Mrs. Lena Steele and sent to the men and women from East Bloomfield, N.Y. and surrounding area towns, who served in the armed forces during World War II. The Review contained items about the soldiers, town happenings; births, marriages and deaths. Wonderful source of local history during these years."
						price="10.03"
						image="/images/ebhs/store/thewaryears.png"
					/>
					<Book
						title="Signature Quilts"
						author="Judi Stewart and Joan Hall"
						description="In celebration of the East Bloomfield Historical Society's 50th anniversary, the Society the members were invited to participate in creating a 50th Anniversary Signature Quilt. The book tells the history of signature quilts and contains color photos with the history of the five signature quilts in the Society's collection. The earliest quilt is approximately between 1830 and 1860."
						price="18.74"
						image="/images/ebhs/store/signaturequilts.png"
					/>
				</div>
			</div>
		</>
	)
}

function Book({
	title,
	author = '',
	description,
	price,
	image,
}: {
	title: string
	author?: string
	description: string
	price: string
	image: string
}) {
	return (
		<div className="m-3 w-full max-w-sm rounded-lg bg-white p-3 lg:flex lg:max-w-full">
			<div className="m-3 h-48 flex-none overflow-hidden bg-cover text-center lg:h-auto lg:w-48">
				<img
					className="w-full"
					src={image}
					alt={'Book Cover for ' + title}
				/>
			</div>
			<div className="flex flex-col justify-between p-4 leading-normal">
				<div className="mb-8">
					<div className="mb-2 text-2xl font-semibold text-gray-900">
						{title}
					</div>
					{author ? (
						<p className="flex items-center text-xl text-gray-600">
							By {author}
						</p>
					) : null}
					<p className="mt-2 text-lg text-gray-700">{description}</p>
				</div>
				<div className="px-6 py-4">
					<span className="mr-2 inline-block rounded-full bg-green-200 px-3 py-1 text-2xl font-semibold text-gray-700">
						${price}
					</span>
				</div>
			</div>
		</div>
	)
}
